import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=4693e8d6&scoped=true&"
import script from "./teacher.vue?vue&type=script&lang=ts&"
export * from "./teacher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4693e8d6",
  null
  
)

export default component.exports